import React from "react";
import PropTypes from "prop-types";
import statusToelatingen from "../../common/svg/StatusToelatingen";
import { ToelatingTypes } from "../../../constants/DomainConstants";

const statussen = [
	{ toelatingOK: false, icon: "fa fa-times", className: "toelating-status__icoon--afgekeurd" },
	{ toelatingOK: null, icon: "fa fa-question", className: "toelating-status__icoon--onbeslist" },
	{ toelatingOK: true, icon: "fa fa-check", className: "toelating-status__icoon--goedgekeurd" }
];

function heeftStatus(toelating, toelatingOK) {
	return toelatingOK === null ? toelating.toelatingOK == null : toelating.toelatingOK === toelatingOK;
}

function createLijnen(toelatingen) {
	return statussen.flatMap(status => {
		const metStatus = toelatingen.filter(t => heeftStatus(t, status.toelatingOK));
		const gemeenten = metStatus
			.filter(t => t.type === ToelatingTypes.GEMEENTE)
			.map(t => t.gemeenteNaam)
			.sort((a, b) => a.localeCompare(b));

		const lijnen = [];
		if (gemeenten.length)
			lijnen.push({ label: "Gemeenten :", tekst: gemeenten.join(", ") });
		if (metStatus.some(t => t.type === ToelatingTypes.ANB))
			lijnen.push({ label: "ANB" });
		if (metStatus.some(t => t.type === ToelatingTypes.AWV))
			lijnen.push({ label: "AWV" });

		return lijnen.map(lijn => ({ ...lijn, status }));
	});
}

const ToelatingenStatusTooltip = ({ toelatingen }) => {
	const lijnen = createLijnen(toelatingen).map((lijn, i) =>
		<div key={i} className="toelating-status">
			<i className={`${lijn.status.icon} toelating-status__icoon ${lijn.status.className}`}></i>
			<span className="toelating-status__label">{lijn.label}</span>
			{lijn.tekst && <span>{lijn.tekst}</span>}
		</div>
	);

	return (
		<div className="c-tooltip green toelatingen-tooltip">
			<span className="c-tooltip__trigger toelatingen-knop">{statusToelatingen()}</span>
			<div className="c-tooltip__window align-right">
				<div className="c-tooltip__content">
					<strong className="toelatingen-tooltip__titel">Status van de aangevraagde goedkeuringen</strong>
					{lijnen}
				</div>
			</div>
		</div>
	);
};

ToelatingenStatusTooltip.propTypes = {
	toelatingen: PropTypes.array.isRequired
};

export default ToelatingenStatusTooltip;
